// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/PoolModifyLiquidityTest.sol/PoolModifyLiquidityTest.json

export const POOL_MODIFY_LIQUIDITY_TEST_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_manager",
        "type": "address",
        "internalType": "contract IPoolManager"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "manager",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IPoolManager"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "modifyLiquidity",
    "inputs": [
      {
        "name": "key",
        "type": "tuple",
        "internalType": "struct PoolKey",
        "components": [
          {
            "name": "currency0",
            "type": "address",
            "internalType": "Currency"
          },
          {
            "name": "currency1",
            "type": "address",
            "internalType": "Currency"
          },
          {
            "name": "fee",
            "type": "uint24",
            "internalType": "uint24"
          },
          {
            "name": "tickSpacing",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "hooks",
            "type": "address",
            "internalType": "contract IHooks"
          }
        ]
      },
      {
        "name": "params",
        "type": "tuple",
        "internalType": "struct ModifyLiquidityParams",
        "components": [
          {
            "name": "tickLower",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "tickUpper",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "liquidityDelta",
            "type": "int256",
            "internalType": "int256"
          },
          {
            "name": "salt",
            "type": "bytes32",
            "internalType": "bytes32"
          }
        ]
      },
      {
        "name": "hookData",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "settleUsingBurn",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "takeClaims",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [
      {
        "name": "delta",
        "type": "int256",
        "internalType": "BalanceDelta"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "modifyLiquidity",
    "inputs": [
      {
        "name": "key",
        "type": "tuple",
        "internalType": "struct PoolKey",
        "components": [
          {
            "name": "currency0",
            "type": "address",
            "internalType": "Currency"
          },
          {
            "name": "currency1",
            "type": "address",
            "internalType": "Currency"
          },
          {
            "name": "fee",
            "type": "uint24",
            "internalType": "uint24"
          },
          {
            "name": "tickSpacing",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "hooks",
            "type": "address",
            "internalType": "contract IHooks"
          }
        ]
      },
      {
        "name": "params",
        "type": "tuple",
        "internalType": "struct ModifyLiquidityParams",
        "components": [
          {
            "name": "tickLower",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "tickUpper",
            "type": "int24",
            "internalType": "int24"
          },
          {
            "name": "liquidityDelta",
            "type": "int256",
            "internalType": "int256"
          },
          {
            "name": "salt",
            "type": "bytes32",
            "internalType": "bytes32"
          }
        ]
      },
      {
        "name": "hookData",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "delta",
        "type": "int256",
        "internalType": "BalanceDelta"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "unlockCallback",
    "inputs": [
      {
        "name": "rawData",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "stateMutability": "nonpayable"
  }
] as const;

export const POOL_MODIFY_LIQUIDITY_TEST_BYTECODE = "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" as const;
